import styled from 'styled-components';

// Wraps the standalone /playground page: an intro banner, a live sample changelog
// (rendered by the real Changelog component), and an authoring reference.
export default styled.div`
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    color: #333;

    .pg-banner {
        padding: 32px 40px 4px;
    }

    .pg-kicker {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        color: #a8842c;
        margin: 0 0 6px;
    }

    .pg-title {
        font-size: 26px;
        font-weight: 600;
        color: #1d1d1d;
        margin: 0 0 8px;
    }

    .pg-intro {
        font-size: 15px;
        line-height: 1.6;
        color: #595959;
        max-width: 760px;
        margin: 0;
    }

    .pg-ref {
        padding: 8px 40px 80px;
        border-top: 1px solid #ededed;
        margin-top: 8px;
    }

    .pg-ref h2 {
        font-size: 20px;
        font-weight: 600;
        color: #1d1d1d;
        margin: 24px 0 4px;
    }

    .pg-ref h3 {
        font-size: 15px;
        font-weight: 600;
        color: #1d1d1d;
        margin: 22px 0 6px;
    }

    .pg-reflead {
        font-size: 14px;
        color: #595959;
        margin: 0 0 12px;
    }

    .pg-ref pre {
        background: #f6f8fa;
        border: 1px solid #e6e8eb;
        border-radius: 8px;
        padding: 12px 14px;
        overflow: auto;
        font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
        font-size: 12.5px;
        line-height: 1.55;
        color: #24292f;
        margin: 0;
    }

    code {
        font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
        font-size: 0.9em;
        background: #f4f4f4;
        border-radius: 3px;
        padding: 1px 5px;
    }
`;
